/* terminal/actions */
import { action } from "typesafe-actions";
import { Emv, EmvActionTypes } from "./types";

export const fetchRequest = (
  id?: string | null,
  params?: {},
  callback?: () => unknown | null
) => action(EmvActionTypes.FETCH, { id, params, callback });

export const fetchSuccess = (emv: Emv) =>
  action(EmvActionTypes.FETCH_SUCCESS, emv);

export const fetchError = (error: string) =>
  action(EmvActionTypes.FETCH_ERROR, error);
